<div id="container">
    <button mat-icon-button color="primary" id="icone-zoom" (click)="ouvrirImage()" [disabled]="!donneesImage"
        [matTooltip]="'Visualiser la cartographie ' + ((direction ? 'de ' + direction.nom : '') | lowercase)" *ngIf="donneesImage">
        <img [src]="!donneesImage ? 'assets/icon/cartoGris.png' : 'assets/icon/carto.png'">
    </button>
    <mat-spinner *ngIf="!donneesImage" diameter="20"></mat-spinner>
</div>